import React from "react";
import PropTypes from "prop-types";
import { orderMethods } from "../../../../../shared/constants/order";
import styles from "../NavigationBar.module.css";
import {
  getLocationPinIcon,
  getNavPartProps,
  isNavigationBarBrandRefresh,
} from "../navigationBarBrandRefreshClasses";

const legacyLocationPin = require("../../imgs/location-pin.svg");
const brandRefreshLocationPin = require("../../imgs/brand-refresh-location-pin.svg");
const prominentLocationPin = require("../../imgs/brand-refresh-location-pin-prominent.svg");
const brandRefreshCaretDown = require("../../imgs/brand-refresh-caret-down.svg");

const AddressSelector = ({
  prominentNavigation,
  userOrderMethod,
  selectedStore,
  userAddress,
  onToggleHeaderWidget,
}) => {
  const isBrandRefresh = isNavigationBarBrandRefresh();
  const locationPin = getLocationPinIcon(
    legacyLocationPin,
    brandRefreshLocationPin,
  );

  const hasAddressSelected = () => {
    if (userOrderMethod === orderMethods.pickup) {
      return !!selectedStore?.name;
    }
    return !!userAddress?.address1;
  };

  const getLocationString = () => {
    let locationString = "";
    if (userOrderMethod === orderMethods.pickup) {
      locationString = selectedStore?.name || "";
    } else if (
      userAddress?.address1 &&
      userAddress?.savedLocation?.locationLabel?.label
    ) {
      locationString = userAddress.savedLocation.locationLabel.label;
    } else if (userAddress?.address1) {
      locationString = userAddress.address1;
    } else {
      locationString = selectedStore?.name || "";
    }
    return locationString;
  };

  const getAddressLabel = () => {
    const locationStr = getLocationString();
    if (!locationStr) {
      return userOrderMethod === orderMethods.pickup
        ? "Select a store"
        : "Enter delivery address";
    }
    if (userOrderMethod === orderMethods.pickup) {
      return `Pickup at: ${locationStr}`;
    }
    return `Deliver to: ${locationStr}`;
  };

  const getFirstLineText = () => {
    if (!hasAddressSelected()) {
      return "Delivery or Pickup";
    }
    if (userOrderMethod === orderMethods.pickup) {
      return "Pickup from";
    }
    return "Delivery to";
  };

  return (
    <button
      type="button"
      onClick={onToggleHeaderWidget}
      className={`${styles.addressButton} flex items-center gap-2 text-white font-montserratMedium flex-shrink-0 w-auto`}
      aria-label={getAddressLabel()}
      data-part={getNavPartProps("address-button")}
    >
      <img
        src={isBrandRefresh && prominentNavigation ? prominentLocationPin : locationPin}
        alt=""
        className={
          isBrandRefresh
            ? "object-contain hidden md:block"
            : "w-6 h-8 object-contain hidden md:block"
        }
        data-part={getNavPartProps("location-pin")}
      />
      <div
        className={
          isBrandRefresh
            ? "flex flex-col items-start justify-center"
            : "flex flex-col items-start"
        }
        data-part={getNavPartProps("address-text")}
      >
        <span
          className={styles.addressFirstLine}
          data-part={getNavPartProps("address-first-line")}
        >
          {getFirstLineText()}
        </span>
        <span
          className={
            isBrandRefresh ? "flex items-center" : "flex items-center gap-1"
          }
          data-part={getNavPartProps("address-second-row")}
        >
          <span
            className={styles.addressSecondLine}
            data-part={getNavPartProps("address-second-line")}
          >
            {getLocationString() || "Enter address"}
          </span>
          {isBrandRefresh ? (
            <img
              src={brandRefreshCaretDown}
              alt=""
              data-part={getNavPartProps("address-caret")}
            />
          ) : (
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.5 4.5L6 8L9.5 4.5"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </span>
      </div>
    </button>
  );
};

AddressSelector.propTypes = {
  prominentNavigation: PropTypes.bool,
  userOrderMethod: PropTypes.string,
  selectedStore: PropTypes.shape({
    name: PropTypes.string,
  }),
  userAddress: PropTypes.shape({
    address1: PropTypes.string,
    savedLocation: PropTypes.shape({
      locationLabel: PropTypes.shape({
        label: PropTypes.string,
      }),
    }),
  }),
  onToggleHeaderWidget: PropTypes.func.isRequired,
};

AddressSelector.defaultProps = {
  prominentNavigation: false,
  userOrderMethod: "",
  selectedStore: null,
  userAddress: null,
};

export default AddressSelector;
